import React, { useEffect, useState } from 'react'
import { Link, animateScroll as scroll } from 'react-scroll';

export default function Homepage() {

    // Show full service details
    const [isHovered, setIsHovered] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);
    const [isHovered4, setIsHovered4] = useState(false);
    const [isHovered5, setIsHovered5] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseEnter2 = () => {
        setIsHovered2(true);
    };
    const handleMouseEnter3 = () => {
        setIsHovered3(true);
    };
    const handleMouseEnter4 = () => {
        setIsHovered4(true);
    };
    const handleMouseEnter5 = () => {
        setIsHovered5(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const handleMouseLeave2 = () => {
        setIsHovered2(false);
    };
    const handleMouseLeave3 = () => {
        setIsHovered3(false);
    };
    const handleMouseLeave4 = () => {
        setIsHovered4(false);
    };
    const handleMouseLeave5 = () => {
        setIsHovered5(false);
    };

    return (
        <>
            <div className='homepage'>
                <header>
                    <div className="logo">
                        <img alt='نجم تكنو - Najm Tech' src='./imgs/najmTechLogo.png'></img>
                    </div>
                    <div className="navbar">
                        <Link
                            activeClass="active"
                            to="ourServices"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                        >
                            <div className='cls'>خدماتنا</div>
                        </Link>
                        <Link
                            activeClass="active"
                            to="ourPortfolio"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                        >
                            <div className='cls'>أعمالنا</div>
                        </Link>
                        <Link
                            activeClass="active"
                            to="aboutus"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                        >
                            <div className='cls'>عنا</div>
                        </Link>
                    </div>
                    <div className="orderbtn">
                        <a href='https://wa.me/201035357288'>
                            <div className='btn'>
                                اطلب موقعك الآن
                            </div>
                        </a>
                    </div>
                </header>
                <a className='whatsappLink' href='https://wa.me/201035357288'>
                    <span class="wtsapShadow">
                        <img className='whatsappIqon' alt='Whatsapp' src='./imgs/3670051.png'></img>
                    </span>
                </a>
                <div className="main">
                    <div className="aboutus" id='aboutus'>
                        <div className='dotCon'><span class="dot"></span></div>
                        <div className='aLogoContainer'>
                            <div className='animatedLogo'>
                                <div><span class="crcl1"></span><div className='part1'></div></div>
                                <div className='part2'></div>
                                <div className='part3'></div>
                                <div><span class="crcl2"></span><div className='part4'></div></div>
                                <div><span class="crcl3"></span><span class="crcl4"></span><div className='part5'></div></div>
                                <div className='part6'></div>
                                <div className='part7'></div><div className='part8'></div>
                                <div><div className='part9'></div>
                                    <div className='part10'></div>
                                </div>
                                <div><span class="crcl5"></span><div className='part11'></div></div>
                                <img className='logoTxt' alt='نجم تكنو' src='./imgs/najmTech.png'></img>
                            </div>
                        </div>
                        <div className='txt'>نقدم حلول تطوير المواقع الإلكترونية التي تعكس هوية ورؤية عملك بإسلوب إبداعي ومتقن، تواصل معنا لبدء رحلة النجاح الرقمي مع شركتك.</div>
                    </div>
                    <div className="services" id="ourServices">
                        <div className='title'>خدماتنا</div>
                        <div className='servicesList'>
                            <div onMouseEnter={handleMouseEnter2}
                                onMouseLeave={handleMouseLeave2}
                                className={isHovered2 ? "hoverdService" : "service"}>
                                {!isHovered2 &&
                                    <div className='withoutHover'>
                                        تطبيقات ويب مخصصة
                                        <br></br>
                                        Web Application
                                    </div>}

                                {isHovered2 &&
                                    <div className='withHover'>
                                        <div className='srvsCont'>
                                            <div className='tit'>
                                                <div>
                                                    تطبيقات ويب مخصصة Web Application
                                                </div>
                                                <img className='serviceImg' src='./imgs/modern-landing-page-template_52683-472-removebg-preview.png'></img>
                                            </div>

                                            <ul>
                                                <li>دومين مجاني لمدة سنة</li>
                                                <li>استضافة مجانية بمساحة 100 جيجا</li>
                                                <li>شهادة SSL مجانا</li>
                                                <li>أرشفة الموقع و تحسينه لمحركات البحث SEO</li>
                                                <li>تصميم احترافي وإمكانية تخصيص تصميم مميز</li>
                                                <li>تصميم متجاوب مع جميع الأجهزة</li>
                                                <li>ربط الموقع بوسائل التواصل الاجتماعي</li>
                                                <li>تخصيص وظائف الموقع حسب الحاجة</li>
                                                <li>الوصول لجميع API's المطلوبة</li>
                                                <li>لوحة تحكم متكاملة وتحديد الوصول للمستخدمين</li>
                                                <li>عدد غير محدود من الصفحات</li>
                                            </ul>
                                            <div className='price'>
                                                السعر من 5999 ج.م إلى 14999 ج.م فقط
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div onMouseEnter={handleMouseEnter3}
                                onMouseLeave={handleMouseLeave3}
                                className={isHovered3 ? "hoverdService" : "service"}>
                                {!isHovered3 &&
                                    <div className='withoutHover'>
                                        مدونة الكترونية
                                        <br></br>
                                        Blog
                                    </div>}

                                {isHovered3 &&
                                    <div className='withHover'>
                                        <div className='srvsCont'>
                                            <div className='tit'>
                                                <div>
                                                    مدونة الكترونية Blog
                                                </div>
                                                <img className='serviceImg' src='./imgs/blog-removebg-preview.png'></img>
                                            </div>

                                            <ul>
                                                <li>دومين مجاني لمدة سنة</li>
                                                <li>استضافة مجانية بمساحة 100 جيجا</li>
                                                <li>شهادة SSL مجانا</li>
                                                <li>أرشفة الموقع و تحسينه لمحركات البحث SEO</li>
                                                <li>تصميم احترافي وإمكانية تخصيص تصميم مميز</li>
                                                <li>تصميم متجاوب مع جميع الأجهزة</li>
                                                <li>ربط الموقع بوسائل التواصل الاجتماعي</li>
                                                <li>لوحة تحكم متكاملة وتحديد الوصول للمستخدمين</li>
                                                <li>عدد غير محدود من الصفحات</li>
                                            </ul>
                                            <div className='price'>
                                                السعر 5499 ج.م فقط
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                className={isHovered ? "hoverdService" : "service"}>
                                {!isHovered &&
                                    <div className='withoutHover'>
                                        موقع الكتروني تعريفي
                                        <br></br>
                                        Portfolio
                                    </div>}

                                {isHovered &&
                                    <div className='withHover'>
                                        <div className='srvsCont'>
                                            <div className='tit'>
                                                <div>
                                                    موقع الكتروني تعريفي Portfolio
                                                </div>
                                                <img className='serviceImg' src='./imgs/portfolio-removebg-preview.png'></img>
                                            </div>
                                            <ul>
                                                <li>دومين مجاني لمدة سنة</li>
                                                <li>استضافة مجانية بمساحة 100 جيجا</li>
                                                <li>شهادة SSL مجانا</li>
                                                <li>أرشفة الموقع و تحسينه لمحركات البحث SEO</li>
                                                <li>تصميم احترافي وإمكانية تخصيص تصميم مميز</li>
                                                <li>تصميم متجاوب مع جميع الأجهزة</li>
                                                <li>ربط الموقع بوسائل التواصل الاجتماعي</li>
                                                <li>عدد غير محدود من الصفحات</li>
                                            </ul>
                                            <div className='order'>
                                                <div className='price'>
                                                    السعر 2999 ج.م فقط
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div onMouseEnter={handleMouseEnter4}
                                onMouseLeave={handleMouseLeave4}
                                className={isHovered4 ? "hoverdService" : "service"}>
                                {!isHovered4 &&
                                    <div className='withoutHover'>
                                        متجر الكتروني
                                        <br></br>
                                        E-Commerce
                                    </div>}

                                {isHovered4 &&
                                    <div className='withHover'>
                                        <div className='srvsCont'>
                                            <div className='tit'>
                                                <div>
                                                    متجر الكتروني E-Commerce
                                                </div>
                                                <img className='serviceImg' src='./imgs/isometric-shopping-online-landing-page_52683-37521-removebg-preview.png'></img>
                                            </div>

                                            <ul>
                                                <li>دومين مجاني لمدة سنة</li>
                                                <li>استضافة مجانية بمساحة 100 جيجا</li>
                                                <li>شهادة SSL مجانا</li>
                                                <li>أرشفة الموقع و تحسينه لمحركات البحث SEO</li>
                                                <li>تصميم احترافي وإمكانية تخصيص تصميم مميز</li>
                                                <li>تصميم متجاوب مع جميع الأجهزة</li>
                                                <li>ربط الموقع بوسائل التواصل الاجتماعي</li>
                                                <li>ربط جميع طرق الدفع</li>
                                                <li>لوحة تحكم متكاملة وتحديد الوصول للمستخدمين</li>
                                                <li>عدد غير محدود من الصفحات</li>
                                            </ul>
                                            <div className='price'>
                                                السعر 5999 ج.م فقط
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div onMouseEnter={handleMouseEnter5}
                                onMouseLeave={handleMouseLeave5}
                                className={isHovered5 ? "hoverdService" : "service"}>
                                {!isHovered5 &&
                                    <div className='withoutHover'>
                                        منصة تعليمية
                                        <br></br>
                                        Educational platform
                                    </div>}

                                {isHovered5 &&
                                    <div className='withHover'>
                                        <div className='srvsCont'>
                                            <div className='tit'>
                                                <div>
                                                    منصة تعليمية Educational platform
                                                </div>
                                                <img className='serviceImg' src='./imgs/online-education-training-isometric-concept_107791-818.jpg'></img>
                                            </div>
                                            <ul>
                                                <li>دومين مجاني لمدة سنة</li>
                                                <li>استضافة مجانية بمساحة 100 جيجا</li>
                                                <li>شهادة SSL مجانا</li>
                                                <li>أرشفة الموقع و تحسينه لمحركات البحث SEO</li>
                                                <li>تصميم احترافي وإمكانية تخصيص تصميم مميز</li>
                                                <li>تصميم متجاوب مع جميع الأجهزة</li>
                                                <li>ربط الموقع بوسائل التواصل الاجتماعي</li>
                                                <li>لوحة تحكم متكاملة وتحديد الوصول للمستخدمين</li>
                                                <li>عدد غير محدود من الصفحات و الدورات</li>
                                            </ul>
                                            <div className='order'>
                                                <div className='price'>
                                                    السعر 5499 ج.م فقط
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className='service'>
                                <div className='withoutHover'>
                                    استضافة المواقع الإلكترونية
                                    <br></br>
                                    Website hosting
                                </div>
                                <div className='withHover'></div>
                            </div>
                            <div className='service'>
                                <div className='withoutHover'>
                                    توجيه الدومين
                                    <br></br>
                                    Domain routing
                                </div>
                                <div className='withHover'></div>
                            </div>
                            <div className='service'>
                                <div className='withoutHover'>
                                    تحسين محركات البحث
                                    <br></br>
                                    SEO
                                </div>
                                <div className='withHover'></div>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio" id='ourPortfolio'>
                        <div className='title'>أعمالنا</div>
                        <div className='portfolioList'>
                            <div className='port'>
                                <div className='description'>
                                    <div className='tit'>مركز دراسات الخليج والقرن الافريقي</div>
                                    <a href='https://www.ghasc.org/'>اذهب للموقع</a>
                                </div>
                                <img className='portImg' alt='Ghasc' src='./imgs/ghasc.png'></img>
                            </div>
                            <div className='port'>
                                <div className='description'>
                                    <div className='tit'>مساحة قيمة المجتمعية</div>
                                    <div>
                                        موقع مخصص &#40;موقع تعريفي + مدونة&#41;</div>
                                    <a href='https://www.qimacommunity.org/'>اذهب للموقع</a>
                                </div>
                                <img className='portImg' alt='Qima Community' src='./imgs/qima.png'></img>
                            </div>
                            <div className='port'>
                                <div className='description'>
                                    <div className='tit'>موقع Earth's Puzzle - لغز الأرض</div>
                                    <div>
                                        مدونة خاصة بمجال الجغرافيا ومجالات أخرى</div>
                                    <a href='https://earths-puzzle.onrender.com/'>اذهب للموقع</a>
                                </div>
                                <img className='portImg' alt='Earths Puzzle' src='./imgs/earthsPuzzle.png'></img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <div className='bigWit'>
                    <div className='bigPur'>
                        <div className='smlwit'>
                            <img alt='najm tech' src='./imgs/najmTechLogo.png'></img>
                            <div className='socialMedia'>
                                <a href='https://wa.me/201035357288'><img alt='whatsappLogo' src='./imgs/whatsappLogo.png'></img></a>
                                <a href='https://www.facebook.com/profile.php?id=61553688064680'><img alt='facebook' src='./imgs/facebook.png'></img></a>
                                <a href='https://www.instagram.com/najm_tech/?fbclid=IwAR1WymMG7afwC31_V9IDnLMty-GhV618n6qAzCS66PDUyuOg1VjXdCRFHew'><img alt='instagram' src='./imgs/instagram.png'></img></a>
                            </div>
                            <div className='rights'>© 2024 جميع الحقوق محفوظة لنچم تكنو</div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
